import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "accordion-header" }
const _hoisted_3 = { class: "accordion-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion-item", { open: $setup.isOpen }]),
    id: $props.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "accordion-title",
        onClick: $setup.toggle
      }, _toDisplayString($props.title), 1 /* TEXT */),
      _renderSlot(_ctx.$slots, "header-actions")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}